import { GetDashboardsResponseDTO, GetEmbedUrlResponseDTO } from '../declarations/reporting';
import { get } from 'api/api';

export const getDashboardIds = async () => {
  const response = await get<GetDashboardsResponseDTO>('/quicksight-dashboards/dashboards');
  return response.data;
};

export const getEmbedUrl = async (dashboardId: string) => {
  const response = await get<GetEmbedUrlResponseDTO>(
    `/quicksight-dashboards/dashboards/${dashboardId}`
  );
  return response.data;
};
